<template lang="pug">
v-card.elevation-1
  .d-flex
    .flex-1
      v-card-title.pa-2.pl-4.font-size-16
        span.font-weight-700 Series en
        span.font-weight-700.primary--text  &nbsp;recall&nbsp;
        span.font-weight-700 {{tipo && tipo.toLowerCase()}}
      v-card-subtitle.pb-3.font-size-12.grey--text Listado  de tickets que  ingresar con la misma serie
    v-btn.ma-2( color="info"  small  @click="$refs.pieChart.fetchTicketsEnRecall()")
      v-icon sync
      | Actualizar
  v-divider
  .d-flex.mx-1(v-if="count")
    .flex-1.ma-2
      v-card.pa-2.text-xs-center.elevation-1(height="100%")
        .d-flex.ai-center.jc-center.fd-column
          .display-1.font-weight-700 {{cantidadTicketsEnRecall}}
          span.font-size-12 Total de tickets
  .d-flex.mx-4
    v-switch(v-model='incluirCerrados' dense, label="Incluir busqueda en tickets cerrados" @change="reRenderChart()")
  pie-chart(
    v-if="renderChart"
    :tipo="tipo"
    ref="pieChart"
    @count="obtenerCantidad",
    @click="obtenerSeleccionado",
    :incluir-cerrados="incluirCerrados"
  )
  v-expand-transition
    v-card.transition-fast-in-fast-out.v-card--reveal.elevation-0(v-if='reveal' height='100%', :loading="isLoading")
      .d-flex.fd-column
        v-card-title.pa-2.pl-4.font-size-16
          v-btn(color='primary' fab x-small @click='reveal = false')
            v-icon arrow_back
          span.font-weight-700.ml-3 Tickets con la serie
          span.font-weight-700.primary--text  &nbsp;{{serieRecall}}&nbsp;
      v-card.elevation-0.overflow-y-auto(height="300")
        ticket-summary-info.animated.fadeInUp.faster(
          :key="index"
          v-for="(o, index) in ticketsEnRecall"
          :ticket="o"
          :is-chart="true"
        )
      //- v-card-actions
      //-   v-btn(color='primary' block small @click='reveal = false')
      //-     | Regresar al KPI
</template>
<script>
import { apiGet, notify } from '../util/general'
import PieChart from './c_chart_bar_tickets_en_recall'
import TicketSummaryInfo  from './c_item_ticket_lista'
export default {
  name: 'c_card_chart_bar_tickets_en_recall',
  components : {
    PieChart,
    'ticket-summary-info': TicketSummaryInfo
  },
  props: {
    tipo : {
      type   : String,
      default: 'garantia'
    },
    count : {
      type   : Boolean,
      default: false
    }
  },
  data () {
    return {
      reveal                 : false,
      isLoading              : false,
      renderChart            : true,
      serieRecall            : '',
      incluirCerrados        : false,
      ticketsEnRecall        : [],
      cantidadTicketsEnRecall: 0
    }
  },
  methods : {
    obtenerCantidad (count) {
      var vm = this
      vm.cantidadTicketsEnRecall = count
    },
    obtenerSeleccionado (item) {
      var vm = this
      vm.serieRecall = item
      vm.fetchTicketsDeSerieEnRecall()
      vm.reveal = true
    },
    fetchTicketsDeSerieEnRecall () {
      var vm = this
      vm.isLoading = true
      var obj = {
        tipo           : vm.tipo.toLowerCase(),
        incluirCerrados: vm.incluirCerrados ? 1 : 0,
        serie          : vm.serieRecall
      }
      console.log('obj', obj)
      apiGet(vm, '/ticket/abiertos/count/recall', obj, function (data) {
        vm.ticketsEnRecall = data.data
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isLoading = false
      })
    },
    reRenderChart () {
      var vm = this
      vm.renderChart = false
      vm.$nextTick(() => {
        vm.renderChart = true
      })
    }
  }
}
</script>
<style lang="stylus" scoped>
.v-card--reveal
  bottom: 0;
  opacity: 1 !important;
  position: absolute;
  width: 100%;
</style>



// WEBPACK FOOTER //
// c_card_chart_bar_tickets_en_recall.vue?b8cff93a